$(document).ready(function() {
    // $('.home-carousel').owlCarousel({
    //     margin: 0,
    //     autoplay: true,
    //     dots: true,
    //     //nav: true,
    //     loop: true,
    //     smartSpeed: 450,
    //     autoplayTimeout: 4000,

    //     responsive: {
    //         0: {
    //             items: 1
    //         },
    //         600: {
    //             items: 1
    //         },
    //         1000: {
    //             items: 1
    //         }
    //     }
    // });


    // $('.details-carousel').owlCarousel({
    //     loop: true,
    //     margin: 0,
    //     nav: false,
    //     dosts: true,
    //     autoplay: true,
    //     autoplayTimeout: 7000,
    //     responsive: {
    //         0: {
    //             items: 2
    //         },
    //         600: {
    //             items: 4
    //         },
    //         1000: {
    //             items: 5
    //         }
    //     }
    // })

    $(".search").click(function() {
        $(".search-form-wrapper").toggle();
    });

    $("#show-div").click(function() {
        $("#show-div-details").show();
    });

    // Add minus icon for collapse element which is open by default
    $(".collapse.show").each(function() {
        $(this).prev(".card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
    });

    // Toggle plus minus icon on show hide of collapse element
    $(".collapse").on('show.bs.collapse', function() {
        $(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
    }).on('hide.bs.collapse', function() {
        $(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
    });


    window.incrementValue = (e) => {
        e.preventDefault();
        var fieldName = $(e.target).data('field');
        var parent = $(e.target).closest('div');
        var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

        if (!isNaN(currentVal)) {
            parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
        } else {
            parent.find('input[name=' + fieldName + ']').val(0);
        }
    }

    window.decrementValue = (e) => {
        e.preventDefault();
        var fieldName = $(e.target).data('field');
        var parent = $(e.target).closest('div');
        var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

        if (!isNaN(currentVal) && currentVal > 0) {
            parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
        } else {
            parent.find('input[name=' + fieldName + ']').val(0);
        }
    }

    $('.input-group').on('click', '.button-plus', function(e) {
        incrementValue(e);
    });

    $('.input-group').on('click', '.button-minus', function(e) {
        decrementValue(e);
    });

    $('.alywhel').click(function() {

        $(this).parent().parent().parent().removeClass('show');
    });

    $('.fltr-shw').click(function() {
        $(this).next().addClass('show');
        $('.shwmbl-flter').show();
    });

    $('.opac-layer').click(function() {

        $('.srch-bx').hide();
    });

    $(document).on('click', '.opac-layer', function() {
        $('.srch-bx').fadeOut();
    });

    $(document).on('click', '.btn-search ', function() {
        $('.srch-bx').fadeIn();
    });

    $(document).on('click', '.search-form ', function() {
        $('.srch-bx').fadeIn();
    });

    $(document).on('click', '.search ', function() {
        $('.srch-bx').fadeIn();
    });



    // btn-search 



})